import * as React from 'react';
import {styled, styledDiv} from '@packages/utilities/styled';

import {
  UserInviteIcon,
  UserDeleteIcon,
  HelpCircleIcon,
  UserUpdateIcon,
} from '@packages/systems/spring';

const FlowIconWrapper = styledDiv(({theme: {colors, gutters}}) => ({
  gridRow: '1 / 3',
  width: gutters.x12 * 3,
  height: gutters.x12 * 3,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${colors.border}`,
  borderRadius: '4px',
  color: colors.white,
  backgroundColor: colors.logicFlows.backgroundVivid,
}));

export const StyledHelpIcon = styled(HelpCircleIcon)(({theme}) => ({
  width: theme.control.height / 2,
  height: theme.control.height / 2,
  boxSizing: 'content-box',
  color: theme.colors.foregroundDim,
  position: 'relative',
  top: '2px',
}));

export const InviteUserIcon = () => {
  return (
    <FlowIconWrapper>
      <UserInviteIcon size={20} />
    </FlowIconWrapper>
  );
};

export const DeleteUserIcon = () => {
  return (
    <FlowIconWrapper>
      <UserDeleteIcon size={20} />
    </FlowIconWrapper>
  );
};

export const UpdateUserIcon = () => {
  return (
    <FlowIconWrapper>
      <UserUpdateIcon size={20} />
    </FlowIconWrapper>
  );
};
